import React from 'react';
import InnerHTML from '@Components/InnerHTML';

// eslint-disable-next-line import/prefer-default-export
export function SubstanceCommercialSupplierInformationCellAvailability(props) {
  const { stockStatus, shipmentTier, productLocation, lastUpdated } = props;

  return (
    <td className="column-availability">
      {stockStatus && (
        <div>
          Stock availability: <InnerHTML tag="span" html={stockStatus === 'true' ? 'available' : stockStatus} />
        </div>
      )}
      {shipmentTier && (
        <div>
          Shipping Time <InnerHTML tag="span" html={shipmentTier} />
        </div>
      )}
      {productLocation && (
        <div>
          Shipment country: <InnerHTML tag="span" html={productLocation} />
        </div>
      )}
      <div>
        Last updated: <InnerHTML tag="span" html={lastUpdated} />
      </div>
    </td>
  );
}
